import 'bootstrap/dist/css/bootstrap.min.css';
import 'font-awesome/css/font-awesome.min.css';
import './App.css';
import { MsalProvider} from "@azure/msal-react";
import Home from './Home';

export default function App({ msalInstance }) {
  return (
    <MsalProvider instance={msalInstance}>
      <div className="container-fluid">
        <Home/>      
      </div>
    </MsalProvider>
  );
}
